import Image from 'next/image'
import { type FC, type JSX } from 'react'
import { FormattedMessage } from 'react-intl'

import { useGlobalConfigContext } from '../../../../../../global-config'
import { TENANT } from '../../../../../../tenant'
import { assetUrlGetPrefixed } from '../../../../../../url-handling'
import { type FooterTenantLinks } from '../../../../config/PerTenantFooterConfiguration.type'

const tenantOrder = [
  TENANT.COM,
  TENANT.BE,
  TENANT.AT,
  TENANT.CH,
  TENANT.FR,
  TENANT.IT,
]

const countryNameByTenant: Record<TENANT, JSX.Element> = {
  [TENANT.AT]: <FormattedMessage id="footer.flag.austria.label" />,
  [TENANT.BE]: <FormattedMessage id="footer.flag.belgium.label" />,
  [TENANT.CH]: <FormattedMessage id="footer.flag.switzerland.label" />,
  [TENANT.COM]: <FormattedMessage id="footer.flag.germany.label" />,
  [TENANT.FR]: <FormattedMessage id="footer.flag.france.label" />,
  [TENANT.IT]: <FormattedMessage id="footer.flag.italy.label" />,
}

const assetsCountryFlagLogoMap: Record<TENANT, string> = {
  [TENANT.AT]: '/images/flags/flag-austria.svg',
  [TENANT.BE]: '/images/flags/flag-belgium.svg',
  [TENANT.CH]: '/images/flags/flag-switzerland.svg',
  [TENANT.COM]: '/images/flags/flag-germany.svg',
  [TENANT.FR]: '/images/flags/flag-france.svg',
  [TENANT.IT]: '/images/flags/flag-italy.svg',
}

type FooterShopsProps = {
  tenantLinksItems: FooterTenantLinks
}

export const FooterShops: FC<FooterShopsProps> = ({ tenantLinksItems }) => {
  const { assetsPrefix } = useGlobalConfigContext()

  return (
    <ul className="flex shrink-0 flex-wrap justify-center gap-3 tablet:flex-nowrap tablet:justify-end">
      {tenantOrder.map((tenant) => (
        <li key={tenant}>
          <a
            className="inline-flex items-center gap-2"
            href={tenantLinksItems[tenant]}
          >
            <Image
              alt=""
              height={20}
              src={assetUrlGetPrefixed(
                assetsPrefix,
                assetsCountryFlagLogoMap[tenant],
              )}
              unoptimized
              width={30}
            />
            {countryNameByTenant[tenant]}
          </a>
        </li>
      ))}
    </ul>
  )
}
